// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UBbj","select":"styles_select__1Tyvc"};